module.exports = __webpack_public_path__ + "img/pr-1.fd202e25.png";